import {
	type CommentCreateDto,
	patchOrderIdCommentsCommentId,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { orderKeys } from "Order/Api/orderKeys";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

const orderMutationsResource = Resources.base.order.mutations;

export const useUpdateOrderCommentMutation = (orderId: number) => {
	const { t } = useResource();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse(
			(args: { data: CommentCreateDto; commentId: number }) =>
				patchOrderIdCommentsCommentId(args.data, orderId, args.commentId),
		),
		onError: (error) => {
			console.error(
				`${t(orderMutationsResource.orderCommentUpdateError)}:`,
				error,
			);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: orderKeys.comments(orderId) });
			toast.success(t(orderMutationsResource.orderCommentUpdateSuccess));
		},
	});
};
